import React from 'react';
import BenefitsChecklistContainer from './BenefitsChecklist.style';

interface Props {
  borderBottomRightRadius?: number;
  borderBottomLeftRadius?: number;
  maxWidth?: number;
  padding?: string;
  backgroundColor?: string;
  fontColor?: string;
  children: React.ReactNode;
}
const BenefitsChecklist = (props: Props) => {
  return (
    <BenefitsChecklistContainer
      padding={props.padding}
      backgroundColor={props.backgroundColor}
      borderBottomLeftRadius={props.borderBottomLeftRadius}
      borderBottomRightRadius={props.borderBottomRightRadius}
      maxWidth={props.maxWidth}
      fontColor={props.fontColor}
    >
      {props.children}
    </BenefitsChecklistContainer>
  );
};

export default BenefitsChecklist;
